import { render } from "./Eurasier.vue?vue&type=template&id=05e0573f&scoped=true"
import script from "./Eurasier.vue?vue&type=script&lang=js"
export * from "./Eurasier.vue?vue&type=script&lang=js"

import "./Eurasier.vue?vue&type=style&index=0&id=05e0573f&scoped=true&lang=css"

import exportComponent from "/Users/jessicabohland/Documents/Code/Website/gonsbachtal-website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05e0573f"]])

export default __exports__